export default async function({$auth, redirect}) {
  if(!$auth.user || $auth.user.role_name!='Patient') {
    redirect('/login')
  }
}